import { sin, cos, sqrt, pi, tau } from "../math.js";
var ka = 0.89081309152928522810;
var kr = sin(pi / 10) / sin(7 * pi / 10);
var kx = sin(tau / 10) * kr;
var ky = -cos(tau / 10) * kr;
export default {
  draw: function draw(context, size) {
    var r = sqrt(size * ka);
    var x = kx * r;
    var y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau * i / 5;
      var c = cos(a);
      var s = sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};